import './ChangePlansContainer.css';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { PlansNotAvailable } from 'Features/Plans/PlansNotAvailable';
import { usePlans } from 'Hooks/usePlans';
import { useSubscription } from 'Hooks/useSubscription';
import { getActivePlanSimplifiedName, isFounderServiceId } from 'Utils/Plans';
import { Loader } from 'Components/Loader';
import plansLanguage from 'Config/PlanStrings.json';
import { ChangePlan } from 'Features/Plans/ChangePlan';
import { timestampToDate } from 'Utils/Format';
import { useParams, Navigate } from 'react-router-dom';
import { useSelectPlans } from 'Hooks/useSelectPlan';

const FOUNDERS_BENEFITS_KEY = 'FOUNDING_MEMBER';

// util functions
const getPlanBenefitKey = ({ packageID }, subscription) =>
  subscription.isFounder && isFounderServiceId(packageID) ? FOUNDERS_BENEFITS_KEY : packageID;

export const ChangePlansContainer = () => {
  const subscription = useSubscription();
  const plans = usePlans();
  const routes = useSelector((s) => s.appConfig.routes);
  const { showBannerPlans } = useSelector((s) => s.appConfig.defaultConfig);
  const { preSelectedPlan = '' } = useParams();

  const selectablePlans = useSelectPlans({ preSelectedPlan, defaultSelect: false });

  const activePlanSimplifiedName = getActivePlanSimplifiedName(plans.allPlans, subscription.activeSubscriptionId);

  const disableCta = !!subscription.nextSubscription;

  //if navigate back here from payment screen after selecting a plan, there will be no preSelectedPlan param
  if (plans.isPlanSelected && preSelectedPlan) {
    return <Navigate to={routes.payment} />;
  }

  if (!plans.selectPlanActionComplete) {
    return (
      <div className="plansContainer">
        <Loader />
      </div>
    );
  }

  if (selectablePlans.length === 0) {
    return <PlansNotAvailable routes={routes} />;
  }

  return (
    <div className="plansContainer">
      <div className="planHeader">Change Plan</div>
      {subscription.nextSubscription && (
        <Fragment>
          <div className="planSubHeader">
            You have your {activePlanSimplifiedName || 'current'} plan until{' '}
            {timestampToDate(subscription.validityTill)}.
          </div>
          <div className="planNote">In order to change plans again, please wait until your next billing cycle.</div>
        </Fragment>
      )}
      <div className="plansList">
        {selectablePlans.map((plan) => {
          const planBenefitsId = getPlanBenefitKey(plan, subscription);
          const plansBenefits = plansLanguage[planBenefitsId];
          return (
            <ChangePlan
              subscription={subscription}
              key={planBenefitsId}
              plan={plan}
              planBenefits={plansBenefits}
              showBannerPlans={showBannerPlans}
              disableCta={disableCta}
            />
          );
        })}
      </div>
      <Link to={routes.myAccount} className="cancelButton">
        Go Back
      </Link>
    </div>
  );
};
